import { useMemo } from 'react'

import { useCurrentUser } from '@modules-deprecated/app/user/currentUserContext'

export const usePredefinedNamePhoneStepValues = () => {
  const { isLoading, user } = useCurrentUser()

  const predefinedValues = useMemo(() => {
    if (isLoading) {
      return undefined
    }

    // The backend sets user.name to the email local part (before @) as a registration fallback.
    const isNameEmailFallback = user?.name === user?.email?.split('@')[0]
    return {
      name: isNameEmailFallback ? '' : (user?.name ?? ''),
      phone: user?.phone ?? '',
    }
  }, [isLoading, user?.email, user?.name, user?.phone])

  return {
    isLoading,
    predefinedValues,
  }
}
